const FIELDSNGO = [
  { label: "all", value: "all" },
  { value: "air pollution", label: "air pollution" },
  { value: "forest", label: "forest" },
  { value: "climate", label: "climate" },
  { value: "ocean", label: "ocean" },
  { value: "rivers", label: "rivers" },
  { value: "agriculture", label: "agriculture" },
  { value: "education", label: "education" },
  { value: "birds", label: "birds" },
  { value: "planting trees", label: "planting trees" },
  { value: "fish", label: "fish" },
  { value: "biodiversity", label: "biodiversity" },
  { value: "waste", label: "waste" },
  { value: "environmental law", label: "environmental law" },
  { value: "eco-building", label: "eco-building" },
  { value: "energy", label: "energy" },
  { value: "transport", label: "transport" },
  { value: "science", label: "science" },
  { value: "plastic pollution", label: "plastic pollution" },
  { value: "protection of reserves", label: "protection of reserves" },
  { value: "wildlife protection", label: "wildlife protection" },
  { value: "turtles protection", label: "turtles protection" },
  { value: "wetlands", label: "wetlands" },
  { value: "water conservation", label: "water conservation" },
  { value: "domestic animals", label: "domestic animals" }
];

export default FIELDSNGO;
